import React from 'react'
import Spinner from '@/components/Spinner'

interface SignInContainerProps {
  children: React.ReactNode
  loading: boolean
}

export default function SignInContainer({
  children,
  loading,
}: SignInContainerProps) {
  return (
    <section className="splash-icon" style={{ minHeight: '770px' }}>
      {loading && <Spinner />}
      <div className="signin-box">{children}</div>
    </section>
  )
}
